<div class="page-content fade-in-up">
    <div class="row">
        <div class="col-12">
            <div class="ibox">
                <div class="ibox-head">
                    <div class="ibox-title">Users</div>
                </div>
                <div class="ibox-body">
                    <ul class="nav nav-tabs tabs-line">
                        <li class="nav-item">
                            <a class="nav-link active" *ngIf="list_flag" (click)="refresh()" data-toggle="tab"><i
                                    class="fa fa-line-chart"></i> User List</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" *ngIf="create_flag" (click)="refresh()" data-toggle="tab"><i
                                    class="fa fa-plus-circle" aria-hidden="true"> </i> Create User
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" *ngIf="add_user_flag" (click)="refresh()" data-toggle="tab"><i
                                    class="fa fa-plus-circle" aria-hidden="true"> </i> Add User
                            </a>
                        </li>
                        <!-- <li class="nav-item">
                            <a class="nav-link" href="#tab-7-3" data-toggle="tab"><i class="ti-settings"
                                    aria-hidden="true"> </i> Update User
                            </a>
                        </li> -->

                    </ul>
                    <div class="tab-content">
                        <div *ngIf="list_flag">
                            <br>
                            <div class="row">
                                <div class="col-4">
                                    <mat-form-field style="margin-left: 2%">
                                        <input matInput (keyup)="applyFilter($any($event.target).value)"
                                            placeholder="Filter">
                                    </mat-form-field>
                                </div>
                                <div class="col-7 text-right">
                                    <button (click)="open_add_user()" class="btn btn-primary">Add User</button>
                                </div>
                                <!-- <div class="col-1 text-right">
                                    <button (click)="open_create()" class="btn btn-primary">Map User</button>
                                </div> -->


                            </div>


                            <div class="example-container">

                                <table mat-table [dataSource]="datasource" matSort>



                                    <ng-container matColumnDef="user_id">
                                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>User ID


                                        </th>
                                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                            {{ element.user_id }} </td>
                                    </ng-container>

                                    <ng-container matColumnDef="name">
                                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>User Name


                                        </th>
                                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                            {{ element.party_name }} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="phone_no">
                                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Phone No


                                        </th>
                                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                            {{ element.phone_no }} </td>
                                    </ng-container>

                                    <ng-container matColumnDef="email">
                                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Email
                                        </th>
                                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                            {{ element.contact_email}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="role_desc">
                                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Role
                                            Description
                                        </th>
                                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                            {{ element.role_name}} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="action">
                                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Action
                                        </th>
                                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                            <button (click)="modalOpen(element)"
                                                class="btn btn-danger">Delete</button>
                                        </td>
                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                                    </tr>
                                </table>
                                <mat-paginator [pageSizeOptions]="[10, 20,50,80,100]"
                                    showFirstLastButtons></mat-paginator>
                            </div>

                        </div>

                        <div *ngIf="create_flag">
                            <div class="card">
                                <div style="margin: 5%;">
                                    <br>
                                    <div class="row">
                                        <div class="col-12 text-right">
                                            <button (click)="open_list()" class="btn btn-primary">Open
                                                List</button>
                                        </div>
                                    </div>

                                    <!-- <div class="row">
                                <div class="col-3"></div>
                                <div class="col-3">
                                    <h6 style="margin-left: 2%;">
                                        Enter Mobile Number : <span style="color: red;">*</span></h6>
                                </div>
                                <div class="col-3">
                                    <input type="email" placeholder="Enter Mobile Number" class="form-control" [(ngModel)]="Obj['credential']">
                                </div>
                                <div class="col-3"></div>

                            </div>
                            <br>
                            <div class="row">
                                <div class="col-12 text-center">
                                    <button (click)="search()" class="btn btn-primary">Search</button>
                                </div>
                            </div>
                            <br>
                            <hr> -->
                                    <br>
                                    <div class="row">
                                        <div class="col-3"></div>
                                        <div class="col-3">
                                            <h6 style="margin-left: 2%;">Select User : <span style="color: red;">
                                                    *</span>
                                            </h6>
                                        </div>
                                        <div class="col-3">
                                            <ng-select [items]="allSearchableEmp" bindLabel="desc" bindValue="user_id"
                                                [multiple]="false" placeholder="Select User"
                                                [(ngModel)]="Obj['user_id']" [selectableGroup]="true"
                                                (change)="setDetails()" [selectableGroupAsModel]="true"
                                                name="chart_of_account0">res
                                            </ng-select>
                                        </div>
                                        <div class="col-3"></div>
                                    </div>
                                    <br>

                                    <div class="row">
                                        <div class="col-3"></div>
                                        <div class="col-3">
                                            <h6 style="margin-left: 2%;"> Select Role : <span
                                                    style="color: red;">*</span></h6>
                                        </div>
                                        <div class="col-3">
                                            <ng-select [multiple]="false" placeholder="Select Role"
                                                [items]="current_role" bindLabel="role_name" bindValue="role_cd"
                                                [selectableGroup]="true" [selectableGroupAsModel]="false"
                                                aria-placeholder="Select Role" [closeOnSelect]="true" name="hierarchy"
                                                [(ngModel)]="Obj['role_cd']">
                                            </ng-select>
                                        </div>
                                        <div class="col-3"></div>


                                    </div>
                                    <br>

                                    <div class="row">
                                        <div class="col-12 text-center">
                                            <button class="btn btn-primary" (click)="submit()">Submit</button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div *ngIf="update_flag">
                            <div class="card">
                                <div style="margin: 5%;">
                                    <div class="row">
                                        <div class="col-12 text-right">
                                            <button (click)="open_list()" class="btn btn-primary">Open
                                                List</button>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-4">
                                            <h6 style="margin-left: 2%;">
                                                Enter Email :</h6>
                                        </div>
                                        <div class="col-4">
                                            <input type="email" placeholder="Enter email" class="form-control"
                                                [(ngModel)]="Obj['email']">
                                        </div>
                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-4">
                                            <h6 style="margin-left: 2%;"> Enter Phone Number : <span
                                                    style="color: red;">*</span></h6>
                                        </div>
                                        <div class="col-4">
                                            <input type="number" placeholder="Enter Phone Number" class="form-control"
                                                [(ngModel)]="Obj['phone_no']">
                                        </div>
                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-12 text-center">
                                            <button class="btn btn-primary" (click)="update()">Update</button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div *ngIf="add_user_flag">
                            <mat-horizontal-stepper [linear]="isLinear" #stepper1>
                                <mat-step [stepControl]="first" label="Search" completed="false">

                                    <br>
                                    <br>

                                    <div class="row">
                                        <div class="col-4 text-center">
                                            <h6>Enter Mobile Number/Email : <span style="color: red;">*</span> </h6>
                                        </div>
                                        <div class="col-4">
                                            <input type="email" class="form-control"
                                                [(ngModel)]="joiningObj['credential']">
                                        </div>
                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-12 text-center">
                                            <button class="btn btn-danger" (click)=open_list()>Cancel</button>
                                            &nbsp;&nbsp;
                                            <button class="btn btn-primary" (click)="search1()">Search</button>
                                        </div>

                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-12 text-center">
                                            <!-- <button mat-button mat-raised-button class="btn btn-success"
                                                 matStepperNext>Next</button> -->
                                        </div>
                                    </div>

                                </mat-step>
                                <br>
                                <br>
                                <br>
                                <mat-step [stepControl]="second" label="Identity">

                                    <br>
                                    <br>
                                    <div class="row">
                                        <div class="col-5">
                                            <hr class="hrline">
                                        </div>
                                        <div class="col-2 text-center">
                                            <h6 id="h" style="color: brown; min-height: 20px;">
                                                Person Info
                                            </h6>
                                        </div>
                                        <div class="col-5">
                                            <hr class="hrline">
                                        </div>
                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-4 text-center">

                                            Person Id : <span style="color: red;">*</span>
                                        </div>
                                        <div class="col-4">
                                            <input type="text" class="form-control" placeholder="system assiged"
                                                [(ngModel)]="joiningObj['le_id']" disabled>
                                        </div>

                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-4 text-center">

                                            Person Name : <span style="color: red;">*</span>
                                        </div>
                                        <div class="col-4">
                                            <input type="text" class="form-control" *ngIf="disable_flag==true"
                                                [(ngModel)]="joiningObj['emp_name']" disabled>
                                            <input type="text" class="form-control" *ngIf="disable_flag==false"
                                                [(ngModel)]="joiningObj['emp_name']">
                                        </div>

                                    </div>
                                    <br>

                                    <div class="row">
                                        <div class="col-4 text-center">

                                            Email : <span style="color: red;">*</span>
                                        </div>
                                        <div class="col-4">
                                            <input type="email" class="form-control" *ngIf="disable_flag==true"
                                                [(ngModel)]="joiningObj['emp_email']" disabled>
                                            <input type="email" class="form-control" #ngInput
                                                *ngIf="disable_flag==false" [(ngModel)]="joiningObj['emp_email']"
                                                (ngModelChange)="checkEmail(ngInput.value)">
                                            <!-- <span style="color:red" *ngIf="avivalid==false" >Email Not Valid</span> -->
                                            <ng-container *ngIf="spanAvi==false; else elseTemplate" style="color: red">
                                                <span style="color: red"> <i>Enter Valid Email</i> </span>
                                            </ng-container>
                                            <ng-template #elseTemplate style="color: green">
                                                <span style="color: green"> <i>Email Is Valid</i></span>
                                            </ng-template>

                                        </div>
                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-4 text-center">

                                            Phone : <span style="color: red;">*</span>
                                        </div>
                                        <div class="col-4">
                                            <input type="number" class="form-control" *ngIf="disable_flag==true"
                                                [(ngModel)]="joiningObj['emp_phone_no']" disabled>
                                            <input type="number" class="form-control" *ngIf="disable_flag==false"
                                                [(ngModel)]="joiningObj['emp_phone_no']">
                                        </div>

                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-4 text-center">

                                            Person DOB : <span style="color: red;">*</span>
                                        </div>
                                        <div class="col-4">
                                            <input type="date" class="form-control" *ngIf="dob_blank==false "
                                                [(ngModel)]="joiningObj['emp_dob']" disabled>
                                            <input type="date" class="form-control" *ngIf="dob_blank==true"
                                                [(ngModel)]="joiningObj['emp_dob']">
                                        </div>

                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-12 text-center">
                                            <button mat-button mat-raised-button class="btn btn-danger"
                                                (click)=open_list()>Cancel</button> &nbsp;&nbsp;
                                            <button mat-button mat-raised-button class="btn btn-primary"
                                                matStepperPrevious>Back</button> &nbsp;&nbsp;
                                            <!--Back-->
                                            <button mat-button mat-raised-button class="btn btn-success"
                                                *ngIf="avivalid" matStepperNext>Next</button>
                                            <!--Next-->


                                        </div>
                                    </div>



                                </mat-step>
                                <br>
                                <br>
                                <br>
                                <mat-step [stepControl]="third" label="Assignment">
                                    <br>
                                    <br>
                                    <div class="row">
                                        <div class="col-5">
                                            <hr class="hrline">
                                        </div>
                                        <div class="col-2 text-center">
                                            <h6 id="h" style="color: brown; min-height: 20px;">
                                                Employee Info:
                                            </h6>
                                        </div>
                                        <div class="col-5">
                                            <hr class="hrline">
                                        </div>
                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-3 text-left">
                                            <h6 style="margin-left: 2%;">
                                                Employee Id <span style="color:red">*</span>:
                                            </h6>
                                        </div>
                                        <div class="col-4">
                                            <input type="text" class="form-control" [(ngModel)]="joiningObj['emp_id']">
                                        </div>
                                    </div>
                                    <br>

                                    <div class="row">
                                        <div class="col-5">
                                            <hr class="hrline">
                                        </div>
                                        <div class="col-2 text-center">
                                            <h6 id="h" style="color: brown; min-height: 20px;">
                                                Assigned Zone :
                                            </h6>
                                        </div>
                                        <div class="col-5">
                                            <hr class="hrline">
                                        </div>
                                    </div>
                                    <br>
                                    <br>
                                    <div class="row">

                                        <!-- <div class="row"> -->
                                        <div class="col-3 text-left">
                                            <h6 style="margin-left: 2%;">
                                                Select Zone <span style="color:red">*</span>:
                                            </h6>
                                        </div>
                                        <div class="col-4">
                                            <ng-select [items]="mainService1.codeValueTechObj['USTP10']"
                                                bindLabel="code" bindValue="value" [multiple]="false" placeholder=""
                                                [(ngModel)]="joiningObj['zone']" [selectableGroup]="true"
                                                [selectableGroupAsModel]="false" [closeOnSelect]="true"
                                                name="field_name">
                                            </ng-select>
                                        </div>
                                        <!-- </div> -->

                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-5">
                                            <hr class="hrline">
                                        </div>
                                        <div class="col-2 text-center">
                                            <h6 id="h" style="color: brown; min-height: 20px;">
                                                Functional Area :
                                            </h6>
                                        </div>
                                        <div class="col-5">
                                            <hr class="hrline">
                                        </div>
                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-3 text-left">
                                            <h6 style="margin-left: 2%;">
                                                Functional Area <span style="color:red">*</span>:
                                            </h6>
                                        </div>
                                        <div class="col-6">
                                            <ng-select [items]="allModule"
                                                (change)="selectedModule(joiningObj['module_cd'])"
                                                bindLabel="module_name" bindValue="module_cd" [multiple]="true"
                                                placeholder="" [selectableGroup]="true"
                                                [(ngModel)]="joiningObj['module_cd']" [selectableGroupAsModel]="false"
                                                [closeOnSelect]="false" name="field_name">
                                            </ng-select>
                                        </div>
                                        <br>
                                    </div>
                                    <br>
                                    <hr>
                                    <br>
                                    <div class="row">
                                        <div class="col-5">
                                            <hr class="hrline">
                                        </div>
                                        <div class="col-2 text-center">
                                            <h6 id="h" style="color: brown; min-height: 20px;">
                                                Select Node Access:
                                            </h6>
                                        </div>
                                        <div class="col-5">
                                            <hr class="hrline">
                                        </div>
                                    </div>
                                    <br>


                                    <div class="row">
                                        <div class="col-3 text-left">
                                            <h6 style="margin-left: 2%;">
                                                Select Node <span style="color:red">*</span>:
                                            </h6>
                                        </div>
                                        <div class="col-3">
                                            <button class="btn btn-primary"
                                                (click)="open_activitypopup()">Select
                                                Employee Node</button>
                                        </div>
                                        <br>
                                        <div class="col-3 text-left">
                                            <h6 style="margin-left: 2%;">
                                                Selected Node Path:
                                            </h6>
                                        </div>
                                        <div class="col-3 text-left">
                                            {{Obj['path_desc']}}
                                        </div>
                                    </div>
                                    <br>

                                    <!-- Set Employee Node -->


                                    <!-- <br>

                                    <div class="row">
                                        <div class="col-12 text-center">
                                            <h6>Employee Primary Assignment </h6>
                                        </div>
                                    </div>
                                    <br>

                                    <br>
                                    <div class="row">
                                        <div class="col-3 text-center">
                                            Functional Area
                                        </div>
                                        <div class="col-2">
                                            <ng-select [items]="allModule" (change)="ChangeModuleOnPrimary(joiningObj['module_cd'])" bindLabel="module_name" bindValue="module_cd" [multiple]="false" placeholder="" [selectableGroup]="true" [(ngModel)]="joiningObj['module_cd']" [selectableGroupAsModel]="false"
                                                [closeOnSelect]="true" name="field_name">
                                            </ng-select>
                                        </div>
                                        <br>
                                        <div class="col-3 text-center">
                                            Department/Cost Center*
                                        </div>
                                        <div class="col-2">
                                            <ng-select [items]="cost_centerOnPRI" bindLabel="cost_center_desc" bindValue="cost_center_code" [multiple]="false" placeholder="" [selectableGroup]="true" [(ngModel)]="joiningObj['cost_center']" [selectableGroupAsModel]="false" [closeOnSelect]="true"
                                                name="field_name">
                                            </ng-select>
                                        </div>

                                    </div>
                                    <br>
                                    <br>
                                    <br>
                                    <div class="row">
                                        <div class="col-12 text-center">

                                            <h6>Employee secondary Assignment </h6>
                                        </div>
                                        <div class="col-11 text-right">
                                            <button class="btn btn-primary" (click)="addRow()"><i class="fa fa-plus"
                                                    aria-hidden="true"></i></button>
                                        </div>

                                    </div>


                                    <br> -->

                                    <!--------------princy------------------------>

                                    <!-- <div *ngFor="let ln of AllCCRow; let i = index;">


                                        <div class="row">
                                            <div class="col-3 text-center">
                                                Functional Area
                                            </div>
                                            <div class="col-2">
                                                <ng-select [items]="allModule" (change)="ChangeModule(ln['module_cd'],i)" bindLabel="module_name" bindValue="module_cd" [multiple]="false" placeholder="" [selectableGroup]="true" [(ngModel)]="ln['module_cd']" [selectableGroupAsModel]="false" [closeOnSelect]="true"
                                                    name="field_name">
                                                </ng-select>

                                            </div>
                                            <div class="col-3 text-center">
                                                Department/Cost Center*
                                            </div>
                                            <div class="col-2">
                                                <ng-select [items]="cost_center" bindLabel="cost_center_desc" bindValue="cost_center_code" [multiple]="false" placeholder="" [selectableGroup]="true" [(ngModel)]="ln['cost_center']" [selectableGroupAsModel]="false" [closeOnSelect]="true" name="field_name">
                                                </ng-select>
                                            </div>
                                            <div class="col-2">
                                                <button class="btn btn-danger " (click)="deleteRow(i)"><i
                                                        class="fa fa-trash" aria-hidden="true"></i></button>
                                            </div>
                                        </div>
                                    </div> -->

                                    <br>
                                    <div class="row">
                                        <div class="col-12 text-center">
                                            <button mat-button mat-raised-button class="btn btn-danger"
                                                (click)=open_list()>Cancel</button> &nbsp;&nbsp;
                                            <button mat-button mat-raised-button class="btn btn-primary"
                                                matStepperPrevious>Back</button> &nbsp;&nbsp;
                                            <!--Back-->
                                            <button mat-button mat-raised-button class="btn btn-success"
                                                matStepperNext>Next</button>
                                            <!--Next-->


                                        </div>
                                    </div>



                                </mat-step>
                                <br>
                                <br>
                                <br>

                                <mat-step [stepControl]="fourth" label="Done">
                                    <br>
                                    <br>
                                    <div class="row">
                                        <div class="col-5">
                                            <hr class="hrline">
                                        </div>
                                        <div class="col-2 text-center">
                                            <h6 id="h" style="color: brown; min-height: 20px;">
                                                Person Info:
                                            </h6>
                                        </div>
                                        <div class="col-5">
                                            <hr class="hrline">
                                        </div>
                                    </div>
                                    <br>

                                    <div class="row">
                                        <div class="col-4 text-center">
                                            Person Id:
                                        </div>
                                        <div class="col-4">
                                            <input class="form-control" [(ngModel)]="joiningObj['le_id']"
                                                placeholder="system assigned" disabled>
                                        </div>

                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-4 text-center">
                                            Person Name:
                                        </div>
                                        <div class="col-4">
                                            <input class="form-control" [(ngModel)]="joiningObj['emp_name']" disabled>
                                        </div>

                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-4 text-center">
                                            Email:
                                        </div>
                                        <div class="col-4">
                                            <input class="form-control" [(ngModel)]="joiningObj['emp_email']" disabled>
                                        </div>

                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-4 text-center">
                                            Phone:
                                        </div>
                                        <div class="col-4">
                                            <input class="form-control" [(ngModel)]="joiningObj['emp_phone_no']"
                                                disabled>
                                        </div>
                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-4 text-center">
                                            Person DOB:
                                        </div>
                                        <div class="col-4">
                                            <input class="form-control" [(ngModel)]="joiningObj['emp_dob']" disabled>
                                        </div>
                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-4 text-center">
                                            Employee Id:
                                        </div>
                                        <div class="col-4">
                                            <input class="form-control" [(ngModel)]="joiningObj['emp_id']" disabled>
                                        </div>
                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-4 text-center">
                                            Select Zone:
                                        </div>
                                        <div class="col-4">
                                            <ng-select [items]="mainService1.codeValueTechObj['USTP10']"
                                                bindLabel="code" bindValue="value" [multiple]="false" placeholder=""
                                                [(ngModel)]="joiningObj['zone']" [selectableGroup]="true"
                                                [selectableGroupAsModel]="false" [closeOnSelect]="true"
                                                name="field_name">
                                            </ng-select>
                                            <!-- <input class="form-control" [(ngModel)]="joiningObj['zone']" disabled> -->
                                        </div>
                                    </div>
                                    <br>
                                    <!-- <br>
                                    <div class="row">
                                        <div class="col-12 text-center">
                                            <h6>Employee Primary Assignment </h6>
                                        </div>
                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-4 text-center">
                                            Functional Area
                                        </div>
                                        <div class="col-4">
                                            <input class="form-control" [(ngModel)]="joiningObj['module_cd']" disabled>
                                        </div>
                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-4 text-center">
                                            Department/Cost Center
                                        </div>
                                        <div class="col-4">
                                            <input class="form-control" [(ngModel)]="joiningObj['cost_center']" disabled>
                                        </div>
                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-12 text-center">
                                            <h6>Employee secondary Assignment </h6>
                                        </div>
                                    </div>
                                    <br>
                                    <div *ngFor="let ln of AllCCRow; let i = index;">


                                        <div class="row">
                                            <div class="col-3 text-center">
                                                Functional Area
                                            </div>
                                            <div class="col-2">
                                                <ng-select disabled [items]="allModule" (change)="ChangeModule(ln['module_cd'],i)" bindLabel="module_name" bindValue="module_cd" [multiple]="false" placeholder="" [selectableGroup]="true" [(ngModel)]="ln['module_cd']" [selectableGroupAsModel]="false"
                                                    [closeOnSelect]="true" name="field_name">
                                                </ng-select>

                                            </div>
                                              <div class="col-3 text-center">
                                                Department/Cost Center*
                                            </div>
                                            <div class="col-2">
                                                <ng-select disabled [items]="cost_center" bindLabel="cost_center_desc" bindValue="cost_center_code" [multiple]="false" placeholder="" [selectableGroup]="true" [(ngModel)]="ln['cost_center']" [selectableGroupAsModel]="false" [closeOnSelect]="true" name="field_name">
                                                </ng-select>
                                            </div>
                                        </div>
                                    </div> -->
                                    <br>
                                    <div class="row">
                                        <div class="col-5">
                                            <hr class="hrline">
                                        </div>
                                        <div class="col-2 text-center">
                                            <h6 id="h" style="color: brown; min-height: 20px;">
                                                Functional Area:
                                            </h6>
                                        </div>
                                        <div class="col-5">
                                            <hr class="hrline">
                                        </div>
                                    </div>
                                    <br>
                                    <div class="row">
                                        <div class="col-3 text-left">
                                            <h6 style="margin-left: 2%;">
                                                Functional Area :
                                            </h6>
                                        </div>
                                        <div class="col-6">
                                            <ng-select [items]="allModule" disabled
                                                (change)="selectedModule(joiningObj['module_cd'])"
                                                bindLabel="module_name" bindValue="module_cd" [multiple]="true"
                                                placeholder="" [selectableGroup]="true"
                                                [(ngModel)]="joiningObj['module_cd']" [selectableGroupAsModel]="false"
                                                [closeOnSelect]="false" name="field_name">
                                            </ng-select>
                                        </div>
                                        <br>
                                    </div>
                                    <br>
                                    <hr>
                                    <br>
                                    <div class="row">
                                        <div class="col-5">
                                            <hr class="hrline">
                                        </div>
                                        <div class="col-2 text-center">
                                            <h6 id="h" style="color: brown; min-height: 20px;">
                                                Select Node Access:
                                            </h6>
                                        </div>
                                        <div class="col-5">
                                            <hr class="hrline">
                                        </div>
                                    </div>
                                    <br>


                                    <div class="row">
                                        <!-- <div class="col-3 text-left">
                                            <h6 style="margin-left: 2%;">
                                                Select Node :
                                            </h6>
                                        </div>
                                        <div class="col-3">
                                            <button class="btn btn-primary" (click)="open_activitypopup()">Select Employee Node</button>
                                        </div> -->
                                        <br>
                                        <div class="col-3 text-left">
                                            <h6 style="margin-left: 2%;">
                                                Selected Node Path:
                                            </h6>
                                        </div>
                                        <div class="col-3 text-left">
                                            {{Obj['path_desc']}}
                                        </div>
                                    </div>
                                    <br>

                                    <br>
                                    <div class="row">
                                        <div class="col-12 text-center">
                                            <button mat-button mat-raised-button class="btn btn-danger"
                                                (click)=open_list()>Cancel</button> &nbsp;&nbsp;
                                            <button mat-button mat-raised-button class="btn btn-primary"
                                                matStepperPrevious>Back</button> &nbsp;&nbsp;
                                            <!--Back-->
                                            <button mat-button mat-raised-button class="btn btn-success"
                                                (click)="addJoining()">Submit</button>
                                            <!--Next-->
                                        </div>
                                    </div>
                                    <br>
                                </mat-step>


                            </mat-horizontal-stepper>
                        </div>
                    </div>
                    <br>
                </div>
            </div>

        </div>
    </div>

</div>
<ngx-spinner>Loading....</ngx-spinner>
<div class="modal" id="myModal1">
    <div class="modal-dialog modal-lg" style="max-width: 80%;">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <h4 class="modal-title" style="font: bold; ">All Roles</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <!-- Modal body -->
            <div class="modal-body">
                <div class="card">
                    <div style="margin: 2%;">
                        <table class="table table-borederd" style="width: 80%; margin-left: 10%;">
                            <thead>
                                <tr>
                                    <th>S No.</th>
                                    <th>Role Description</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of single_users_role,let i=index">
                                    <td>{{i+1}}</td>
                                    <td>{{item['role_desc']}}</td>
                                    <td>
                                        <button class="btn btn-danger"
                                            *ngIf="single_users_role.length==1 && item['role_cd']=='PROP_EMP'"
                                            (click)="delete(item)">Delete</button>
                                        <button class="btn btn-danger"
                                            *ngIf="single_users_role.length==1 && item['role_cd']!='PROP_EMP'"
                                            (click)="delete(item)">Delete</button>
                                        <button class="btn btn-danger"
                                            *ngIf="single_users_role.length!=1 && item['role_cd']!='PROP_EMP'"
                                            (click)="delete(item)">Delete</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="modal" id="ACTHIER">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <h4 class="modal-title">Select Employee Node</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <div class="modal-body">
                <div class="row" *ngFor="let item of planing_arrproj,let i =index">
                    <div class="col-3"></div>
                    <div class="col-3" *ngIf="i==0">
                        <h6 style="margin-left: 2%;">Select Node : <span style="color: red;"> *</span></h6>
                        <!-- -->
                    </div>
                    <div class="col-3" *ngIf="i!=0"></div>
                    <div class="col-1">

                        <span *ngIf="item['level']"> Level </span>{{item['level']}}
                        <!---  -->
                    </div>
                    <div class="col-3">
                        <ng-select [items]="item['existing_heirarchy_nodes']" bindLabel="desc" bindValue="node_cd"
                            [multiple]="false" placeholder=" Select  Node" [(ngModel)]="item['hierarchy_type']"
                            [selectableGroup]="true" (change)="setHierarchyNodeitem(item,i)"
                            [selectableGroupAsModel]="true" [closeOnSelect]="true">
                        </ng-select>

                    </div>
                    <div class="col-2" *ngIf="i==planing_arrproj.length-1">
                        <button (click)="down(item,i)" class="btn btn-primary"><i class="fa fa-arrow-down"
                                aria-hidden="true"></i></button> &nbsp;&nbsp;
                        <button (click)="remove(item,i)" class="btn btn-danger">
                            <i class="fa fa-arrow-up" aria-hidden="true"></i></button>
                    </div>
                    <div class="col-3"></div>
                </div>
                <br>
                <div class="row">
                    <div class="col-3"></div>
                    <div class="col-3 ">
                        <h6 style="margin-left: 2%;"> <span style="color: red;">*</span> Current Node Path :
                        </h6>
                    </div>
                    <div class="col-6">
                        {{Obj['path_desc']}}
                    </div>

                </div>
                <br>

                <!-- Modal footer -->
                <div class="modal-footer">
                    <button class="btn btn-primary" (click)="submit_act()">Submit</button>
                    <button type="button" class="btn btn-danger" data-dismiss="modal">CLOSE</button>
                </div>

            </div>
        </div>
    </div>
</div>